import config, { placeholder } from './config';
import store from './store';
import { Performer, PerformerStatus } from 'sensejs/performer/performer.model';

export function getAvatarImage(performer: Performer, size: string){

    if(store.state.safeMode && performer.safe_avatar){
        return `${config.ImageUrl}pimg/${performer.id}/${size}/${performer.safe_avatar.name}`;
    }

    if(!store.state.safeMode && performer.avatar){
        return `${config.ImageUrl}pimg/${performer.id}/${size}/${performer.avatar.name}`;
    }

    return placeholder;
}

export function getSliderImages(performer: Performer, photo: any, size: string){
    if(store.state.safeMode && photo.safe_version){
        return `${config.ImageUrl}pimg/${performer.id}/${size}/${photo.name}`;
    }

    if(!store.state.safeMode){
        return `${config.ImageUrl}pimg/${performer.id}/${size}/${photo.name}`;
    }

    return placeholder;
}

export function getParameterByName(name: string, url?: string) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/util.ts